import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { DOCUMENTS_SOURCE_NAME_MAX_LENGTH } from 'const/limits'
import { SubmissionError } from 'redux-form'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import AddDocumentSourceForm from './AddDocumentSourceForm'

export class AddDocumentSource extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    leftSidebar: PropTypes.object.isRequired,

    requestAddDocumentSource: PropTypes.func.isRequired
  }

  cancelForm = () => {
    this.props.leftSidebar.pop()
  }

  handleFormSubmit = ({ name, pluginForm: { identifier, args } }) => {
    const {
      intl,
      requestAddDocumentSource
    } = this.props

    return new Promise((resolve, reject) => {
      if (!name) {
        throw new SubmissionError({
          name: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_EMPTY' }),
          _error: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_EMPTY' })
        })
      } else if (name.length > DOCUMENTS_SOURCE_NAME_MAX_LENGTH) {
        const error = intl.formatMessage(
          { id: 'DOCUMENTS_SOURCES_NAME_TOO_LONG' },
          { limit: DOCUMENTS_SOURCE_NAME_MAX_LENGTH }
        )

        throw new SubmissionError({
          name: error,
          _error: error
        })
      }

      requestAddDocumentSource({
        name,
        identifier,
        args,
        onSuccess: () => resolve(),
        onFail: (error) => {
          if (error.code === 300) {
            reject(new SubmissionError({
              name: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_DUPLICATE' }),
              _error: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_DUPLICATE' })
            }))
          } else {
            throw error
          }
        }
      })
    }).then(() => {
      this.cancelForm()
    })
  }

  render () {
    return (
      <LeftSidebarView
        title={<FormattedMessage id='DOCUMENTS_SOURCE_ADD' />}
      >
        <ViewBody>
          <AddDocumentSourceForm
            onSubmit={this.handleFormSubmit}
            onCancelClick={this.cancelForm}
          />
        </ViewBody>
      </LeftSidebarView>
    )
  }
}

export default injectIntl(withLeftSidebar(AddDocumentSource))
